import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProgressTrackerService } from '../services/progress-tracker.service';

@Component({
    selector: 'progress-tracker',
    templateUrl: 'progress-tracker.component.html',
    standalone: false
})
export class ProgressTrackerComponent implements OnInit, OnDestroy {

    public currentStep: number = 0;
    private onStepChangeSubscription: any;

    constructor(private _trackerService:ProgressTrackerService) {}

    ngOnInit() {
        this.onStepChangeSubscription =
        this._trackerService.onStepChanged.subscribe((res: any) => {
            this.currentStep = this._trackerService.step;
        });
    }

    ngOnDestroy() {
        this.onStepChangeSubscription.unsubscribe();
    }

}
